module.exports = __webpack_public_path__ + "img/headshot-andy-adamson@1x.bd038ccd.png";